import { render, staticRenderFns } from "./TrafficMap.vue?vue&type=template&id=c0e80e68&scoped=true&"
import script from "./TrafficMap.vue?vue&type=script&lang=js&"
export * from "./TrafficMap.vue?vue&type=script&lang=js&"
import style0 from "./TrafficMap.vue?vue&type=style&index=0&id=c0e80e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e80e68",
  null
  
)

export default component.exports